import React from "react";
import { Route as ReactRoute, RouteProps, useHistory, Redirect } from "react-router-dom";
import AdminLogin from "../components/pages/dashboard/AdminLogin";
import ParticipantLogin from "../components/pages/portal/ParticipantLogin";

// Hooks
import { useFetchUser } from "../hooks/useFetchUser";

// Components
import Loading from "../components/general/Loading";

// Settings
import settings from "../settings.json";

export interface CustomRouteProps {
    Component: React.FC<any>;
    readonly isPrivate?: boolean;
    readonly roles?: string[];
    readonly rolesAllowed?: string[];
    readonly title?: string;
    [index: string]: any; // rest
}

const Route: React.FC<CustomRouteProps> = ({
    Component,
    isPrivate = true,
    LayoutComponent = null,
    roles = [],
    rolesAllowed = [],
    title,
    ...rest
}) => {
    const hist = useHistory();
    const { currentAdmin, currentParticipant, fetchingUser } = useFetchUser();

    if (title) document.title = `${title} - ${settings.app.title}`;

    if (fetchingUser) {
        return <Loading loading={true} />;
    }

    if (!currentAdmin) {
        if (hist.location.pathname.includes("/dashboard") && hist.location.pathname !== "/dashboard/login") {
            // return <Redirect to="/dashboard/login" />;
            return <AdminLogin />;
        } else if (
            !hist.location.pathname.includes("/dashboard") &&
            !currentParticipant &&
            hist.location.pathname !== "/login" &&
            hist.location.pathname !== "/unauthorized"
        ) {
            // return <Redirect to="/login" />;
            return <ParticipantLogin />;
        }
    }

    if (currentAdmin) roles = currentAdmin.roles;

    if (rest.path.includes("/dashboard")) {
        if (
            (currentAdmin && currentAdmin.roles && currentAdmin.roles.length === 0) ||
            (rolesAllowed.length > 0 && !!roles.length && !rolesAllowed.some(r => roles.includes(r))) ||
            (currentAdmin && currentAdmin.isDeleted)
        ) {
            // deny access to user not having the appropriate roles
            return <Redirect to="/unauthorized" />;
        }
    }

    return (
        <ReactRoute
            {...rest}
            render={(routeProps: RouteProps) => {
                if (!isPrivate) {
                    if (LayoutComponent) {
                        return (
                            <LayoutComponent>
                                <Component {...routeProps} />
                            </LayoutComponent>
                        );
                    } else {
                        return <Component {...routeProps} />;
                    }
                }
                return (
                    <LayoutComponent>
                        <Component {...routeProps} />
                    </LayoutComponent>
                );
            }}
        />
    );
};

export default Route;
